/*!
 * Copyright (c) 2018-2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var forge = require('node-forge');

var base58 = forge.util.binary.base58;

var LDKeyPair = /*#__PURE__*/function () {
  /**
   *  Note: Actual key material
   * (like `publicKeyBase58` for Ed25519 or
   * `publicKeyPem` for RSA) is handled in the subclass.
   * An LDKeyPair can encrypt private key material.
   * @classdesc The Abstract Base Class on which KeyPairs are based.
   * @example
   * // LDKeyPair is an Abstract Class and should only
   * // be used as a base class for other KeyPairs.
   * @param {KeyPairOptions} [options={}] -
   * See [KeyPairOptions]{@link ./index.md#KeyPairOptions}.
   * @param {string} [options.passphrase=null] - For encrypting the private key.
   * @param {string} options.id - The Key id.
   * @param {string} options.controller - DID of the person/entity controlling
   *   this key.
   * @param {string} [options.owner]  - DID or URI of owner. DEPRECATED, use
   *  `controller` instead.
   */
  function LDKeyPair() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LDKeyPair);

    this.passphrase = options.passphrase || null;
    this.id = options.id;
    this.controller = options.controller;
    this.owner = options.owner; // this.type is set in subclass constructor
    // this.publicKey* and this.privateKey* is handled in sub-classes
  }
  /**
   * @abstract
   * @interface
   * @readonly
   *  Returns the public key.
   * @throws  If not implemented by the subclass.
   *
   * @returns {string} A public key.
   */


  _createClass(LDKeyPair, [{
    key: "publicNode",

    /**
     * Contains the encryption type & public key for the KeyPair
     * and other information that json-ld Signatures can use to form a proof.
     * @param {Object} [options={}] - Needs either a controller or owner.
     * @param {string} [options.controller=this.controller]  - DID of the
     * person/entity controlling this key pair.
     * @param {string} [options.owner=this.owner] - DID of key owner.
     * Deprecated term, use `controller`.
     * @example
     * > ldKeyPair.publicNode();
     * {id: 'test-keypair-id', owner: 'did:uuid:example'}
     *
     * @returns {Object} A public node with
     * information used in verification methods by signatures.
     */
    value: function publicNode() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$controller = _ref.controller,
          controller = _ref$controller === void 0 ? this.controller : _ref$controller,
          _ref$owner = _ref.owner,
          owner = _ref$owner === void 0 ? this.owner : _ref$owner;

      var publicNode = {
        id: this.id,
        type: this.type
      };

      if (controller) {
        publicNode.controller = controller;
      }

      if (owner) {
        publicNode.owner = owner;
      }

      this.addEncodedPublicKey(publicNode); // Subclass-specific

      return publicNode;
    } // publicKeyPem, publicKeyJwk, publicKeyHex, publicKeyBase64, publicKeyBase58

    /**
     * Exports the publicNode with an encrypted private key attached.
     * @example
     * > const withPrivateKey = await edKeyPair.export();
     *
     * @returns {KeyPairOptions} A public node with encrypted private key.
     * @see [KeyPairOptions]{@link ./index.md#KeyPairOptions}
     */

  }, {
    key: "export",
    value: function () {
      var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var keyNode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keyNode = this.publicNode();
                return _context.abrupt("return", this.addEncryptedPrivateKey(keyNode));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _export() {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "publicKey",
    get: function get() {
      throw new Error('Abstract method, must be implemented in subclass.');
    }
    /**
     * @abstract
     * @interface
     * @readonly
     *  Returns the private key.
     * @throws If not implemented by the subclass.
     *
     * @returns {string} A private key.
     */

  }, {
    key: "privateKey",
    get: function get() {
      throw new Error('Abstract method, must be implemented in subclass.');
    }
    /**
     * Generates an LdKeyPair using SerializedLdKey options.
     * @param {SerializedLdKey} options - Options for generating the KeyPair.
     * @example
     * > const options = {
     *    type: 'RsaVerificationKey2018',
     *    passphrase: 'Test1234'
     *  };
     * > const keyPair = await LDKeyPair.generate(options);
     *
     * @returns {Promise<LDKeyPair>} An LDKeyPair.
     * @throws Unsupported Key Type.
     * @see [SerializedLdKey]{@link ./index.md#SerializedLdKey}
     */

  }], [{
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var Ed25519KeyPair, RSAKeyPair;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = options.type;
                _context2.next = _context2.t0 === 'Ed25519VerificationKey2018' ? 3 : _context2.t0 === 'RsaVerificationKey2018' ? 5 : 7;
                break;

              case 3:
                Ed25519KeyPair = require('./Ed25519KeyPair');
                return _context2.abrupt("return", Ed25519KeyPair.generate(options));

              case 5:
                RSAKeyPair = require('./RSAKeyPair');
                return _context2.abrupt("return", RSAKeyPair.generate(options));

              case 7:
                throw new Error("Unsupported Key Type: ".concat(options.type));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function generate(_x) {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
    /**
     * Generates a KeyPair from some options.
     * @param {SerializedLdKey} options  - Will generate a key pair
     * in multiple different formats.
     * @see [SerializedLdKey]{@link ./index.md#SerializedLdKey}
     * @example
     * > const options = {
     *    type: 'Ed25519VerificationKey2018',
     *    passphrase: 'Test1234'
     *   };
     * > const edKeyPair = await LDKeyPair.from(options);
     *
     * @returns {Promise<LDKeyPair>} A LDKeyPair.
     * @throws Unsupported Key Type.
     */

  }, {
    key: "from",
    value: function () {
      var _from = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var Ed25519KeyPair, RSAKeyPair;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = options.type;
                _context3.next = _context3.t0 === 'Ed25519VerificationKey2018' ? 3 : _context3.t0 === 'RsaVerificationKey2018' ? 5 : 7;
                break;

              case 3:
                Ed25519KeyPair = require('./Ed25519KeyPair');
                return _context3.abrupt("return", Ed25519KeyPair.from(options));

              case 5:
                RSAKeyPair = require('./RSAKeyPair');
                return _context3.abrupt("return", RSAKeyPair.from(options));

              case 7:
                throw new Error("Unsupported Key Type: ".concat(options.type));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function from(_x2) {
        return _from.apply(this, arguments);
      }

      return from;
    }()
    /**
     * Creates an instance of LDKeyPair from a key fingerprint.
     * Note: Only key types that use their full public key in the fingerprint
     * are supported (so, currently, only 'ed25519').
     *
     * @param {string} fingerprint
     * @returns {LDKeyPair}
     * @throws Unsupported Fingerprint Type.
     */

  }, {
    key: "fromFingerprint",
    value: function fromFingerprint(_ref2) {
      var fingerprint = _ref2.fingerprint;
      // skip leading `z` that indicates base58 encoding
      var buffer = base58.decode(fingerprint.substr(1)); // buffer is: 0xed 0x01 <public key bytes>

      if (buffer[0] === 0xed && buffer[1] === 0x01) {
        var Ed25519KeyPair = require('./Ed25519KeyPair');

        return new Ed25519KeyPair({
          publicKeyBase58: base58.encode(buffer.slice(2))
        });
      }

      throw new Error("Unsupported Fingerprint Type: ".concat(fingerprint));
    }
    /**
     * Generates a
     * [pdkdf2]{@link https://en.wikipedia.org/wiki/PBKDF2} key.
     * @param {string} password - The password for the key.
     * @param {string} salt - Noise used to randomize the key.
     * @param {number} iterations - The number of times to run the algorithm.
     * @param {number} keySize - The byte length of the key.
     * @example
     * > const key = await LdKeyPair.pbkdf2('Test1234', salt, 10, 32);
     *
     * @returns {Promise<Object>} A promise that resolves to a pdkdf2 key.
     * @see https://github.com/digitalbazaar/forge#pkcs5
     */

  }, {
    key: "pbkdf2",
    value: function () {
      var _pbkdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(password, salt, iterations, keySize) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  forge.pkcs5.pbkdf2(password, salt, iterations, keySize, function (err, key) {
                    return err ? reject(err) : resolve(key);
                  });
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function pbkdf2(_x3, _x4, _x5, _x6) {
        return _pbkdf.apply(this, arguments);
      }

      return pbkdf2;
    }()
  }]);

  return LDKeyPair;
}();

module.exports = LDKeyPair;